// src/components/Footer.tsx

import React from 'react';
import '../css/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>&copy; 2017 Techmark Universal All Rights Reserved.</p>
      {/* <p>
        <a href="/terms">Terms & Conditions</a> | <a href="/privacy">Privacy Policy</a>
      </p> */}
    </footer>
  );
};

export default Footer;
